
export default function Footer() {
  return (
    <footer className="bg-[#1d1d1f] py-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/332f65bd5c6c697fc606d8fa0ef7c66b.png"
              alt="VAZ Global Capital"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-[#D4AF37] font-serif italic text-base">
              Where AI Builds Your Business.
            </p>
          </div>

          <div className="flex flex-wrap gap-8">
            {[
              { label: 'Home', href: '#home' },
              { label: 'Industries', href: '#industries' },
              { label: 'Framework', href: '#framework' },
              { label: 'Consultation', href: '#consultation' },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-xs font-medium tracking-wide uppercase text-[#86868b] hover:text-[#D4AF37] transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="w-full h-px bg-white/10 mb-8"></div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#86868b]">
            &copy; 2026 VAZ Global Capital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
